import React from 'react'
import TimeSection from './Time/TimeSection';

const Time = ({ id, header }) => {


    return (
        <TimeSection id={id} header={header}/>
    )
}
export default Time
